import { gql } from '@apollo/client'

export default gql(`
query hyperionListSubscriptionActivities( $subscriptionId: ID!) {
    hyperionListSubscriptionActivities( 
        subscriptionId: $subscriptionId
    ) {
        id
        subscriptionId
        eventDate
        eventName
        customerId
        planId
        providerId
    }
}`)
